import messages from './header-translations';
import * as $ from 'jquery';

export default {
    name: 'instamapsHeader',
    i18n: {
        messages,
    },
    data: function () {
        return {
            isMobileMenuShown: false,
        };
    },
    props: {
        isViewerMode: { type: Boolean },
        isUserLogged: { type: Boolean },
    },
    methods: {
        showLanguageSelector: function () {
           $('#language-selector').addClass('show-language-menu');
        },
        hideLanguageSelector: function () {
            $('#language-selector').removeClass('show-language-menu');
        },
        toggleLanguageSelector: function (event) {
            if (event.target.className !== 'language-menu-item') {
                ($('#language-selector').hasClass('show-language-menu'))
                    ? this.hideLanguageSelector()
                    : this.showLanguageSelector();
            }
        },
        showVideoSelector: function () {
            $('#video-selector').addClass('show-video-menu');
        },
        hideVideoSelector: function () {
             $('#video-selector').removeClass('show-video-menu');
        },
        toggleVideoSelector: function (event) {
            if (event.target.className !== 'video-menu-item') {
                ($('#video-selector').hasClass('show-video-menu'))
                    ? this.hideVideoSelector()
                    : this.showVideoSelector();
            }
        },
        showPerfilSelector: function () {
            $('#perfil-selector').addClass('show-perfil-menu');
        },
        hidePerfilSelector: function () {
            $('#perfil-selector').removeClass('show-perfil-menu');
        },
        togglePerfilSelector: function (event){
            if (event.target.className !== 'perfil-menu-item') {
                ($('#perfil-selector').hasClass('show-perfil-menu'))
                    ? this.hidePerfilSelector()
                    : this.showPerfilSelector();
            }
        },
        langChange: function (lang) {
            this.hideLanguageSelector();
            this.$emit('langchanged', lang);
        },
        toggle: function () {
            this.isMobileMenuShown = !this.isMobileMenuShown;
            this.$emit('mobileMenuPressed', this.isMobileMenuShown);
        },
        logout: function(){
            this.$emit('logout');
        },
        toProfile: function(){
            this.$emit('toProfile');
        }
    },
};



// WEBPACK FOOTER //
// ./src/shared/components/header/header.js